<template>
  <v-app-bar color="white" absolute elevate-on-scroll scroll-target="#scrolling_sheet">
    <v-container>
      <v-row dense>
        <v-col class="d-flex flex-column">
          <v-card class="transparent" fluid elevation="0">
            <v-list-item class="pl-0">
              <v-list-item-avatar color="d-none d-sm-flex">
                <v-img
                  class="whiteBackground"
                  src="https://file.ilook.su/public/AppInfo/images/logo.png"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="title hidden-sm-and-up"
                >{{this.getSmallTitle}}</v-list-item-title>
                <v-list-item-title
                  class="headline d-none d-sm-flex"
                >{{this.getTitle}}</v-list-item-title>
                <nav class="pa-0 navbar navbar-expand navbar-light">
                  <ul class="pa-0 navbar-nav">
                    <router-link
                      tag="li"
                      class="nav-item"
                      :to="{path:'/', hash:'scrollOnTop'}"
                      @click.native="scrollOnTop"
                      exact
                      active-class="active"
                    >
                      <a
                        class="py-0 pl-0 nav-link"
                      >{{this.$vuetify.lang.translator("appBar.projects")}}</a>
                    </router-link>
                    <router-link
                      tag="li"
                      class="nav-item"
                      :to="{path:'/ios', hash:'scrollOnTop'}"
                      @click.native="scrollOnTop"
                      exact
                      active-class="active"
                    >
                      <a class="py-0 nav-link">ios</a>
                    </router-link>
                    <router-link
                      tag="li"
                      class="nav-item"
                      :to="{path:'/android', hash:'scrollOnTop'}"
                      exact
                      active-class="active"
                    >
                      <a class="py-0 nav-link">android</a>
                    </router-link>
                  </ul>
                </nav>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="auto" class="text-center mr-4 d-none d-sm-flex">
          <v-row class="flex-row fill-height">
            <v-btn class="my-2 mx-1" x-small color="white" icon @click.native="locale = 'ru'">
              <v-img
                :aspect-ratio="1/1"
                :max-width="20"
                src="https://cdn.countryflags.com/thumbs/russia/flag-round-250.png"
              ></v-img>
            </v-btn>
            <v-btn class="my-2 mx-1" x-small color="white" icon @click.native="locale = 'en'">
              <v-img
                :aspect-ratio="1/1"
                :max-width="20"
                src="https://cdn.countryflags.com/thumbs/united-states-of-america/flag-round-250.png"
              ></v-img>
            </v-btn>
            <v-btn class="my-2 mx-1" x-small color="white" icon @click.native="locale = 'es'">
              <v-img
                :aspect-ratio="1/1"
                :max-width="20"
                src="https://cdn.countryflags.com/thumbs/spain/flag-round-250.png"
              ></v-img>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import { eventEmitter } from "../main";

export default {
  components: {},
  data() {
    return {
      locale: this.$vuetify.lang.current,
      meta: { flush: true },
    };
  },
  watch: {
    locale() {
      this.updateLocale(this.locale);
    },
  },
  computed: {
    getTitle(){
      if (this.isSingle){
        return this.$vuetify.lang.translator("appBar.siteTitle")
      }else{
        return this.$vuetify.lang.translator("appBar.siteTitleCorp")
      }
    },
    getSmallTitle(){
      if (this.isSingle){
        return this.$vuetify.lang.translator("appBar.siteTitle")
      }else{
        return this.$vuetify.lang.translator("appBar.siteTitleCorpSmall")
      }
    },
    currentFilter() {
      return location.host;
    },
    isSingle(){
      return location.host == "ilook.su"
    },
    isMain() {
      return this.currentFilter == "all";
    },
  },
  methods: {
    updateLocale(newLocale) {
      this.$vuetify.lang.current = newLocale;
      eventEmitter.$emit("updateLocale");
    },
    scrollOnTop() {
      console.log("scrollOnTop");
      this.$store.commit("resetStoredPosition");
      let sheet = document.getElementById("scrolling_sheet");
      if (sheet) {
        sheet.scroll(0, 0);
      }
    },
  },
};
</script>


<style scoped>
.whiteBackground {
  background-color: #fff;
}
.blur {
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(30px);
}
.transparent {
}
a {
  text-decoration: none;
}
.navbar-nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.nav-fill .nav-item {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  text-align: center;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
  text-decoration: none !important;
}
.nav-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-fill .nav-item {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  text-align: center;
}
.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:hover,
.navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-expand {
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}

.navbar-expand .navbar-nav {
  -ms-flex-direction: row;
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.navbar-expand .navbar-collapse {
  display: -ms-flexbox !important;
  display: flex !important;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
</style>

